import * as React from 'react';
import hoistNonReactStatic from 'hoist-non-react-statics';
import { reduxForm } from 'redux-form';
import { getDisplayName } from 'gandi.react-helpers';
import { jsx as _jsx } from "react/jsx-runtime";
const withForm = config => WrappedComponent => {
  const WithForm = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/_jsx(WrappedComponent, {
    ...props,
    ref: ref
  }));
  const {
    serverHandler,
    ...reduxFormConfig
  } = config;
  const WithFormDecorated = reduxForm({
    getFormState: state => state.gandiForm,
    ...reduxFormConfig
  })(WithForm);
  const HoistedComponent = hoistNonReactStatic(WithFormDecorated, WrappedComponent);
  HoistedComponent.WrappedComponent = WrappedComponent;
  HoistedComponent.displayName = `DecoratorComponent(${getDisplayName(WrappedComponent)})`;
  if (serverHandler) {
    HoistedComponent.handleForm = args => {
      const {
        req
      } = args;
      if (req.method === 'POST') {
        const data = req.body || {};
        const session = req.websession || req.session;
        if (session.csrf && session.csrf.token && data['_csrf_token'] !== session.csrf.token) {
          return Promise.reject('Invalid CSRF token!');
        }
        return serverHandler(args);
      }
      return Promise.resolve();
    };
  }
  return HoistedComponent;
};
export default withForm;